import { Injectable, inject } from '@angular/core';
import { BrowserPlatformService } from '../browser-platform/browser-platform.service';

@Injectable({
    providedIn: 'root',
})
export class MatchMediaService {
    private _browser = inject(BrowserPlatformService);

    constructor() {
        this._setMediaMatches();
    }

    public isPointerCorase: boolean = false;
    public isAnyPointerCorase: boolean = false;
    public isHover: boolean = false;
    public isAnyHover: boolean = false;

    /**
     * setMediaMatches
     */
    private _setMediaMatches() {
        if (this._isMatchMedia('(pointer:coarse)')) {
            this.isPointerCorase = true;
        }
        if (this._isMatchMedia('(hover:hover)')) {
            this.isHover = true;
        }
        if (this._isMatchMedia('(any-pointer:coarse)')) {
            this.isAnyPointerCorase = true;
        }
        if (this._isMatchMedia('(any-hover:hover)')) {
            this.isAnyHover = true;
        }
    }

    private _isMatchMedia(match: string): boolean {
        return this._browser.matchMedia(match);
    }
}
